module.exports = {"description":"","displayName":"PageContentHeader","methods":[],"props":{"title":{"type":{"name":"string"},"required":false,"description":"Page content header text (h1)"},"children":{"type":{"name":"node"},"required":false,"description":"Page content header custom content; overrides title"},"cssMap":{"defaultValue":{"value":"require( './pageContentHeader.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/PageContentHeader-props.json
// module id = 452
// module chunks = 0